const REDIRECT_URL_KEY = 'redirectUrl';

export const getStoredRedirectUrl = () => localStorage.getItem(REDIRECT_URL_KEY);

export const setStoredRedirectUrl = (redirectUrl) => localStorage.setItem(REDIRECT_URL_KEY, redirectUrl);

export const clearStoredRedirectUrl = () => localStorage.removeItem(REDIRECT_URL_KEY);